export default {"src":"/_next/static/media/0x9ca85572e6a3ebf24dedd195623f188735a5179f.9ee92892.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};